import React, { forwardRef } from 'react';

const SecuritySection = forwardRef(function SecuritySection(
  { title, icon = null, children, id, className = '' },
  ref
) {
  return (
    <section ref={ref} className={`vx-sec-section ${className}`.trim()} id={id}>
      <div className="vx-sec-section-header">
        {icon ? <span className="vx-sec-section-icon" aria-hidden="true">{icon}</span> : null}
        <h2 className="vx-sec-section-title">{title}</h2>
      </div>
      {children}
    </section>
  );
});

export default SecuritySection;
